import { Vue, Component } from 'vue-property-decorator'
import { message } from 'ant-design-vue'
import { Modal } from 'ant-design-vue'
const ignoreCodes = { 401: 1, 403: 1 }

/**
 * 本系统所有页面、组件的基类
 */
@Component
export default class ViewBase extends Vue {

  get lan() {
    return this.$store.state.setting.en
  }

  t(value: any) {
    return this.$t(value)
  }
  /**
   * 显示错误信息
   * @param msg 错误信息
   */
  showError(msg: string) {
    message.error(msg)
  }

  /**
   * 显示警告信息
   * @param msg 警告信息
   */
  showWaring(msg: string) {
    message.warning(msg)
  }

  /**
   * 将错误格式化成字符串
   * @param ex 错误对象
   */
  formatError(ex: any = {}) {
    const msg = ex.msg || ex.code ? `${ex.code} ${ex.msg}` : String(ex)
    return msg
  }

  confim(res: any, reslove: any, option: any) {
    this.$confirm({
      title: res.title,
      content: res.content,
      cancelText: `${this.$t('base.cancle')}`,
      okText: `${this.$t('base.sure')}`,
      onOk: () => {
        reslove(option)
      }
    })
  }

  /**
   * 统一处理 ajax catch 异常
   * @param ex 错误对象
   */
  handleError(ex: any = {}) {
    if (!(ex.code in ignoreCodes)) {
      this.$message.destroy()
      const msg = message.warning(this.formatError(ex), 1)
      // this.showError(msg)
      // tslint:disable-next-line
      console.error(msg)
    }
  }
}
